import React from "react"
import { Accordion } from "./Accordion";
import { RadioSelect } from "./RadioSelect";
import { SORT_BY_PRICE_ASC, SORT_BY_PRICE_DESC, SORT_BY_THC_ASC, SORT_BY_THC_DESC, SortByType } from "../types";
import { translate } from "../../../utils/translator";

type Props = {
    sortBy: SortByType;
    setSortBy: React.Dispatch<React.SetStateAction<SortByType>>;
    isOnlyRegulars?: boolean;
    language?: string;
}

export const SortBy: React.FC<Props> = ({ sortBy, setSortBy, isOnlyRegulars, language = "de" }) => {
    return (
        <div
            id="sort-by-price-select-treatment"
            className="px-4 pb-1"
            style={{ borderBottom: "1px solid #DBE1EB" }}
        >
            <Accordion
                title={translate(language, "choose_treatment", "sort_by/title") || "Sortieren nach"}
                defaultOpen={true}
            >
                <div className="flex flex-col gap-3 pt-2">

                    {!isOnlyRegulars &&
                        <>
                            <SortOption
                                title={translate(language, "choose_treatment", "sort_by/price_desc") || "Preis: Absteigend"}
                                globalSortBy={sortBy}
                                sortBy={SORT_BY_PRICE_DESC}
                                setSortBy={setSortBy}
                            />

                            <SortOption
                                title={translate(language, "choose_treatment", "sort_by/price_asc") || "Preis: Aufsteigend"}
                                globalSortBy={sortBy}
                                sortBy={SORT_BY_PRICE_ASC}
                                setSortBy={setSortBy}
                            />
                        </>
                    }

                    <SortOption
                        title={translate(language, "choose_treatment", "sort_by/thc_desc") || "THC: Absteigend"}
                        globalSortBy={sortBy}
                        sortBy={SORT_BY_THC_DESC}
                        setSortBy={setSortBy}
                    />

                    <SortOption
                        title={translate(language, "choose_treatment", "sort_by/thc_asc") || "THC: Aufsteigend"}
                        globalSortBy={sortBy}
                        sortBy={SORT_BY_THC_ASC}
                        setSortBy={setSortBy}
                    />
                </div>
            </Accordion>
        </div>
    )
}


interface SortOptionProps {
    title: string;
    sortBy: SortByType,
    globalSortBy: SortByType,
    setSortBy: React.Dispatch<React.SetStateAction<SortByType>>,
}


const SortOption: React.FC<SortOptionProps> = ({ title, globalSortBy, sortBy, setSortBy }) => {
    const isMobile = window.innerWidth < 768;
    const mobileStyleAttributes = { borderBottom: "none !important", paddingBlock: "0px" };

    return (
        <div
            id={"sort-option-" + title}
            className="cursor-pointer flex items-center gap-2 py-1 last:!border-none pl-[3px]"
            style={{ ...(isMobile && mobileStyleAttributes) }}
            onClick={() => { setSortBy(prev => prev === sortBy ? null : sortBy) }}
        >
            <RadioSelect
                selected={globalSortBy === sortBy}
                size={24}
            />

            <div className="flex flex-col">
                <p
                    className="capitalize text-light"
                    style={{ fontWeight: "300" }}
                >{title}</p>
            </div>
        </div>
    )
}